export enum RcpEmitType {
  REFRESH_DATA = 'REFRESH_DATA',
}
